import { render, staticRenderFns } from "./article-details.vue?vue&type=template&id=8fc768ae&scoped=true&"
import script from "./article-details.vue?vue&type=script&lang=js&"
export * from "./article-details.vue?vue&type=script&lang=js&"
import style0 from "./article-details.vue?vue&type=style&index=0&id=8fc768ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc768ae",
  null
  
)

export default component.exports